import { gql } from '@apollo/client';

import { CART_TOTALS_FRAGMENT } from '@app/pages/Cart/Cart.queries';

export const APPLIED_GIFT_CARDS_FRAGMENT = gql`
  fragment AppliedGiftCards on Magento2_Cart {
    appliedGiftCards {
      code
      appliedBalance {
        value
        currency
      }
      currentBalance {
        value
        currency
      }
      expirationDate
    }
  }
`;

export const APPLY_GIFT_CARD_MUTATION = gql`
  ${APPLIED_GIFT_CARDS_FRAGMENT}
  ${CART_TOTALS_FRAGMENT}

  mutation ApplyGiftCardMutation($cartId: String!, $code: String!) {
    magento2 {
      applyGiftCardToCart(input: { cart_id: $cartId, gift_card_code: $code }) {
        cart {
          id
          ...AppliedGiftCards
          prices {
            ...CartTotals
          }
        }
      }
    }
  }
`;

export const REMOVE_GIFT_CARD_MUTATION = gql`
  ${APPLIED_GIFT_CARDS_FRAGMENT}
  ${CART_TOTALS_FRAGMENT}

  mutation RemoveGiftCardMutation($cartId: String!, $code: String!) {
    magento2 {
      removeGiftCardFromCart(
        input: { cart_id: $cartId, gift_card_code: $code }
      ) {
        cart {
          id
          ...AppliedGiftCards
          prices {
            ...CartTotals
          }
        }
      }
    }
  }
`;

export const APPLIED_GIFT_CARDS_QUERY = gql`
  ${APPLIED_GIFT_CARDS_FRAGMENT}

  query AppliedGiftCardsQuery($cartId: String!) {
    magento2 {
      cart(cart_id: $cartId) {
        id
        ...AppliedGiftCards
      }
    }
  }
`;
